<template>
    <div>
        <span
            v-show="!disableRegister && hasLogin"
            class="mr-3 signin font-weight-bold cursor-pointer"
            @click="login = true"
            :style="{color: color.secondary}"
            v-if="!mobile"
        >{{$t('login.signin')}}</span>
        <login-button
            id="login-button-register"
            v-show="!disableRegister"
            class="ml-2 nch-sigin-button" v-if="!mobile"
            @click="redirect"
        >{{$t('common.register')}}</login-button>
        <login-form
            v-model="login"
            :loginSocial="loginSocial"
            :hubHash="hubHash"
            @forgotPassword="onForgotPassword"
            @openRegister="onRegister()"
            :color="color"
        ></login-form>
        <forgot-password v-if="forgot" v-model="forgot" :color="color" @close="login=true;forgot=false"></forgot-password>
        <register v-model="register" :color="color"></register>
    </div>
</template>

<script>
import BaseButton from '../../argon/components/BaseButton';

import LoginButton from '../Common/LoginButton';
import LoginForm from '../Auth/LoginForm';
import ForgotPassword from '../Auth/ForgotPassword';
import Register from '../Auth/Register';

export default {
    name: 'Home',
    props: {
        color: {
            type: Object,
            required: true,
        },
        disableRegister: Boolean,
        hasForm: [Boolean, Number],
        mobile: Boolean,
        loginSocial: Array,
        hubHash: String,
        hasLogin: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        LoginForm,
        ForgotPassword,
        Register,
        BaseButton,
        LoginButton,
    },
    data() {
        return {
            login: false,
            forgot: false,
            register: false,
        };
    },
    mounted() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'DIALOG_SHOW') {
                return (this.login = state.login.status);
            }
        });
    },
    watch: {
        register(value) {
            this.login = false;
        },
    },
    methods: {
        onForgotPassword() {
            this.login = false;
            this.forgot = true;
            this.$store.commit('DIALOG_HIDE');
        },
        onRegister() {
            if (this.hasForm) {
                this.$loading.show();
                return (location.href = '/register');
            }
            this.register = true;
        },
        redirect() {
            return location.href = '/register';
        },
    },
};
</script>

<style>
.signin {
    transition: opacity .2s;
}
</style>
